module.exports = __webpack_public_path__ + "img/retro_sec6.bb036528.jpg";